import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const groupHeight = 10

const styles = (theme) => {
    return {
        root: css`
            ${custom.border};
            ${custom.boxShadow};
            padding: 15px 30px;
        `,
        main: css`
            ${common.flexJustityAlignCenter};
        `,
        group: css`
            flex-shrink: 1;
            background: ${theme.palette.secondary[200]};
            min-width: 50px;
            height: ${groupHeight}px;
            border-radius: 10px;
            margin-right: 5px;
            &:last-child {
                margin-right: 0;
            }
        `,
        current: css`
            height: ${groupHeight * 2}px;
        `,
        fullyAnswered: css`
            background: ${theme.palette.primary[50]};
        `,
        unAnsweredMandatory: css`
            background: #F0DEBF;
        `,
    }
}

export default styles
